import { useEffect } from 'react';

type Loader = () => Promise<void>;
type Dependencies<T> = T[];

export function useDataLoading<D>(loader: Loader, dependencies: Dependencies<D> = []): void {
    useEffect(() => {
        loader();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...dependencies]);
}
